<mat-slider
    disabled="{{slider.disabled}}"
    invert="{{slider.invert}}"
    max="{{slider.max}}"
    min="{{slider.min}}"
    step="{{slider.step}}"
    thumbLabel="{{slider.thumbLabel}}"
    tickInterval="{{slider.tickInterval}}"
    [(ngModel)]="value"
    (ngModelChange)="sliderValue($event)"
>
</mat-slider>